import { render, staticRenderFns } from "./PlanningMenu.vue?vue&type=template&id=53c7ce9a&scoped=true&"
import script from "./PlanningMenu.vue?vue&type=script&lang=js&"
export * from "./PlanningMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7ce9a",
  null
  
)

export default component.exports